<template>
  <main-dialog
    :is-visible.sync="isDialogVisible"
    :loading="isDialogLoading"
    :title="title"
    agreeText="dialog.agreeSave"
    @agree="saveAsLayer"
    @modalClosed="isDialogVisible = false"
  >
    <template #body>
      <div class="tw:text-left tw:text-font">
        {{ body }}
      </div>
      <div class="tw:mt-4">
        <data-input :data-type="{ name: 'text' }" :label="$i18n.t('dialog.name')" v-model="layerName" hide-details />
      </div>
    </template>
  </main-dialog>
</template>

<script>
import MainDialog from '@/components/MainDialog';
import DataInput from '@/components/DataInput';

import { get, call } from 'vuex-pathify';

export default {
  name: 'SaveGeojsonAsLayerDialog',
  components: {
    MainDialog,
    DataInput,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    body: {
      type: String,
    },
    name: {
      type: String,
    },
    geometry: {
      type: Object,
    },
    styleWeb: {
      type: Object,
    },
  },
  data: vm => ({
    isDialogLoading: false,

    layerName: vm.name,
  }),
  computed: {
    currentUserId: get('users/currentUser@id'),
    isDialogVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
  },
  methods: {
    uploadDataSource: call('layers/uploadDataSource'),
    getLayers: call('layers/getLayers'),
    getDataSources: call('layers/getLayersMetadata'),
    getLayersSchema: call('layers/getLayersSchema'),
    getCurrentUser: call('users/getCurrentUser'),
    async refreshMetadata() {
      await Promise.all([
        this.getCurrentUser(),
        this.getLayersSchema(),
        this.getDataSources({ with_attributes_schema: true, withAdditionalMetadata: true }),
        this.getLayers(),
      ]);
    },
    createFormData() {
      const formData = new FormData();
      const blob = new Blob([JSON.stringify(this.geometry)], { type: 'application/geo+json;charset=utf-8;' });
      const file = new File([blob], this.name);
      const srid = +(this.geometry.crs?.properties?.name.split(':')?.[1] ?? this.$_config.defaultSRID);
      formData.append('geojson', file);
      formData.append('verbose_name', this.layerName);
      formData.append('create_layer', true);
      formData.append('style_web', JSON.stringify(this.styleWeb));
      formData.append('target_srid', srid);
      return formData;
    },
    async saveAsLayer() {
      this.isDialogLoading = true;
      try {
        const formData = this.createFormData();
        await this.uploadDataSource(formData);
        await this.refreshMetadata();
        this.isDialogVisible = false;
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('snackbar.layerAdded'),
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isDialogLoading = false;
      }
    },
  },
  beforeDestroy() {
    this.$emit('close');
  },
};
</script>
